<template>
  <div>
    <section-header heading="2" ja="撮影できるプリクラの枚数は？"/>
    <div class="textArea">
      <p>GIMMI（ギミ）では、「シール用撮影」として4枚と、「追加撮影」として最大15枚を撮影することができます。</p>
      <p>※「シール用撮影」では、シール用とデータ用のプリ画像を撮影することができます。</p>
      <p>※「追加撮影」では、データ専用のプリ画像を任意で撮影することができます。</p>
      <p>※「追加撮影」の最大15枚は、プレイ制限時間内における最大枚数です。</p>
      <p>※プリもっと発動時は、さらに追加で「サプライズショット」1枚を撮影することができます。</p>
    </div>
    <section-header heading="2" ja="撮影したプリクラをダウンロードできる人数は？"/>
    <div class="textArea">
      <p>撮影日から1週間以内に、最大6人までダウンロードすることができます。</p>
      <p>※1週間を過ぎると、撮ったプリクラをダウンロードできなくなります。</p>
    </div>
    <section-header heading="2" ja="撮影日を確認する方法は？"/>
    <div class="textArea">
      <p>撮影日はシールに印字されていますので、シールのご確認をお願いします。またアルバムでも確認できます。</p>
    </div>

    <sub-btn @click="onBack()">戻る</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import SubBtn from '@/components/SubBtn.vue'

export default {
  name: "AboutGimmi02",
  components: {
    SectionHeader,
    SubBtn
  },
  methods: {
    onBack() {
      if(sessionStorage.getItem('prevPage')) {
        this.$router.push(sessionStorage.getItem('prevPage'))
      } else {
        this.$router.push("/AboutGimmi")
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.textArea {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  p {
    margin-top: 1em;
  }
  ul {
    padding-left: 0;
    li {
      list-style-type: none;
      display: block;
    }
  }
}
</style>
